// Crypto (token) wallet endpoints on the investor service.
//
// `POST /api/wallets/crypto` (register an XRPL address with the VASP) is
// deliberately absent: the current designs have no connect-wallet screen, so
// there is nothing to call it from. Add it here alongside a mutation when that
// flow is designed.
//
// Trustline state lives on `GET /api/wallets/crypto/offering-readiness-checks`,
// which is owned by walletShell (see walletEndpointPaths.ts) because it is
// offering-scoped and consumed by the invest eligibility check.
export const CRYPTO_WALLET_ENDPOINTS = {
  WALLET: '/api/wallets/crypto',
  TRANSACTIONS: '/api/wallets/crypto/transactions',
} as const
